import React from 'react';
import {Provider} from "react-redux";
import store from "./redux/store";

import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import NotifBar from './components/NotifBar/NotifBar';
import RegistrationPage from './pages/RegistrationPage/RegistrationPage';
import ConfirmRegistrationPage from './pages/ConfirmRegistrationPage/ConfirmRegistrationPage';
import StatusCheckPage from './pages/StatusCheckPage/StatusCheckPage';
import SampleDataPage from './pages/SampleDataPage/SampleDataPage';
import ReviewSection from './pages/SampleDataPage/ReviewSection';
import ConfirmSampleDataPage from './pages/ConfirmSampleDataPage/ConfirmSampleDataPage';
import AsnPage from './pages/ASN/AsnPage';
import AsnPdfDownload from './pages/ASN/AsnPdfDownload';
import {ToastContainer} from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function App() {
  return (
    <Router>
        <ToastContainer theme="colored"/>
        <NotifBar />
        <Routes>
            <Route path="/" element={<RegistrationPage/>} />
            <Route path="/check-status" element={<StatusCheckPage/>} />
            <Route path="/register-success/:code" element={<ConfirmRegistrationPage/>} />
            <Route path="/sample/:code" element={<SampleDataPage/>} />
            <Route path="/sample-submitted/:code" element={<ConfirmSampleDataPage/>} />
            <Route path="/asn" element={<AsnPage/>} />
            <Route path="/asn/pdf/:id" element={<AsnPdfDownload/>} />
        </Routes>
    </Router>
  );
}

const AppWrapper = () => {
    return (
        <Provider store={store}>
            <App />
        </Provider>
    )
}

export default AppWrapper;